var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40354 8.24611C9.97611 7.8041 10.3775 7.07841 10.3775 6.40549C10.3775 4.91452 9.34451 3.7666 8.01638 3.7666H4.91743C4.59277 3.7666 4.32715 4.06348 4.32715 4.42632V12.343C4.32715 12.7058 4.59277 13.0027 4.91743 13.0027H8.32923C9.55111 13.0027 10.6667 11.8878 10.6726 10.5156C10.6785 9.50618 10.1709 8.64195 9.40354 8.24611ZM6.09798 5.41591H7.86881C8.35874 5.41591 8.75423 5.85792 8.75423 6.40549C8.75423 6.95306 8.35874 7.39507 7.86881 7.39507H6.09798V5.41591ZM8.16395 11.3534H6.09798V9.37424H8.16395C8.65388 9.37424 9.04937 9.81625 9.04937 10.3638C9.04937 10.9114 8.65388 11.3534 8.16395 11.3534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldactive);
export default __webpack_public_path__ + "static/media/boldactive.aa803ad19faf1a7242e01aac500e2ead.svg";
export { ForwardRef as ReactComponent };